import type { SearchTourStep } from './searchTourSteps';

// Reutilizamos el mismo shape que SearchTourStep porque el overlay de spotlight
// trabaja de forma estructural (selector + fallbackSelector + copy).
export const AIDA_TOUR_STEPS: SearchTourStep[] = [
  {
    id: 'new-chat',
    title: 'New chat',
    body: 'Start a fresh conversation with AIDA.',
    selector: '[data-demo-tour="aida-new-chat"]',
    fallbackSelector: '[title="New chat"]',
  },
  {
    id: 'edit-name',
    title: 'Edit chat name',
    body: 'In the sidebar “Recent”, rename the conversation. Click the pencil, then edit the title.',
    selector: '[data-demo-tour="aida-edit-chat-name-input"]',
    fallbackSelector: '[data-demo-tour="aida-edit-chat-name"]',
    prepare: ['aida-open-rename'],
    note: 'If you don’t see the “Recent” list yet, first create a chat from “New chat”.',
  },
  {
    id: 'notify',
    title: 'Notify when ready',
    body: 'Turn on notifications so you can be alerted when AIDA finishes.',
    selector: '[data-demo-tour="aida-notify-when-ready"]',
  },
  {
    id: 'export',
    title: 'Export chat',
    body: 'Export the conversation as a file from the sidebar “Export Chat”.',
    selector: '[data-demo-tour="aida-export-chat"]',
  },
  {
    id: 'suggested',
    title: 'Suggested next questions',
    body: 'Inside the answer, suggested question chips can help you refine the conversation.',
    selector: '[data-demo-tour="aida-suggested-question-chip"]',
    fallbackSelector: '[data-demo-tour="aida-bot-message"]',
    tipPlacement: 'corner',
    note: 'Chips only appear after you receive an answer. This tip stays in the corner when no chip is on screen yet.',
  },
];

